import { Outlet } from "react-router-dom";
import classNames from "classnames";
import "./index.scss";
import { OnboardingFormsHeader } from "components/organisms/OnbordingFormsHeader";

interface IProps {
  theme: "light" | "dark";
}

export const OnboardingFromsMainPage = ({ theme }: IProps) => {
  return (
    <div className={classNames("onboarding-forms-main-page-wrapper")}>
      <div className={classNames("onboarding-forms-header")}>
        <OnboardingFormsHeader />
      </div>
      <div className="onboarding-forms-content-section-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
